import { stringifyQs } from "@saleor/utils/urls";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Pagination,
  SingleAction
} from "../types";
import { SpecialOfferDetailsPageTab } from "./components/SpecialOfferDetails";

const specialOfferSection = "/specialOffer/";
export const specialOfferPath = specialOfferSection;
export type SpecialOfferDialog = "assign-variant" | "unassign-variant";
export type SpecialOfferUrlQueryParams = Pagination &
  SingleAction &
  Dialog<SpecialOfferDialog> &
  BulkAction &
  ActiveTab<SpecialOfferDetailsPageTab>;

export const specialOfferUrl = (params?: SpecialOfferUrlQueryParams) =>
  specialOfferSection + "?" + stringifyQs(params);
